module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_3009.72f81774.png";